<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div class="text-justify">
      <h1 class="my-8 px-4 text-3xl">{{ pageDetails.data?.title }}</h1>

      <div class="bg-[#F0FBFB] border-b-8 border-primary-100 md:pt-20">
        <NuxtLayout
          name="center"
          class="flex flex-col md:flex-row-reverse md:items-start gap-2 md:gap-8"
        >
          <div
            class="py-10 md:py-0 mb-0 md:mb-8 text-lg flex flex-col flex-1 gap-4 max-w-[654px] md:mx-auto"
            v-html="pageDetails.data?.body_text"
          />
          <NuxtImg
            loading="lazy"
            src="/img/refer-a-friend.svg"
            alt=""
            class="mx-auto mt-auto md:mx-0 -mb-[1px] w-full max-w-[12.5rem] md:max-w-[40%] lg:max-w-[327px]"
            width="327"
            height="263"
          />
        </NuxtLayout>
      </div>

      <NuxtLayout name="center">
        <CommonAwardMediaLinks class="py-4 my-2" active="awards" />
        <section class="my-6 pb-12">
          <h2 class="sr-only">Awards</h2>
          <MediaAndAwardsGrid scope="award" />
        </section>
      </NuxtLayout>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { MetaHeads } from "~~/entities/MetaEntities";

interface PageDetailsInterface {
  title: string;
  body_text: string;
}
const { data: pageDetails } =
  await useFetchSafely<MetaHeads<PageDetailsInterface>>(`pages/awards`);

useMetaTitles(pageDetails.value.data);

const breadcrumbs = getBreadcrumbs("awards");
</script>
